<template>
  <div id="contenedor-contrato-contratos-relacionados-tool-bar">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Agregar"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nueva">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoContratosRelacionadosToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    nueva() {
      this.$emit('agregar-contrato-relacionado');
    },
  },
};
</script>

<style lang="scss">

</style>
